import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { List } from 'immutable';
import { PropertyLookupSummary } from '../../shared/models/property-lookup-summary';
import { Constants } from '../../shared/constants';

@Component({
  selector: 'pioneer-property-search-results',
  templateUrl: './property-search-results.component.html',
  styleUrls: [ './property-search-results.component.css' ]
})
export class PropertySearchResultsComponent implements OnInit, OnChanges {

  @Input()
  searchResults: List<PropertyLookupSummary>;

  @Input()
  totalItems: number;

  @Input()
  size: number;

  currentPage: number;

  itemsPerPage = Constants.PROPERTY_SEARCH_ITEMS_PER_PAGE;

  @Output()
  selected = new EventEmitter<PropertyLookupSummary>();

  @Output()
  goToAdd = new EventEmitter();

  hasSearched = false;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    // Initialize currentPage for every search
    this.currentPage = 1;
    if (changes.searchResults && changes.searchResults.previousValue) {
      this.hasSearched = true;
    }
  }

  selectProperty(property: PropertyLookupSummary) {
    this.selected.emit(property);
  }

  getFirstPageItemNumber(): number {
    return (this.currentPage - 1) * this.itemsPerPage;
  }

  getLastPageItemNumber(): number {
    return (this.size < (this.currentPage * this.itemsPerPage)) ? this.size : (this.currentPage * this.itemsPerPage);
  }

  getSize(): number {
    return this.size;
  }

  maxResultsExceeded(): boolean {
    return this.size > Constants.PROPERTY_SEARCH_MAX_RESULTS;
  }

  goToAddProperty(): void {
    this.goToAdd.emit();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/property-search-results/property-search-results.component.ts